module.exports = __webpack_public_path__ + "img/063.9a9450db.png";